import { useState, type FC } from 'react';
import { useNavigate } from 'react-router';
import { observer } from 'mobx-react-lite';
import { Link } from '@g2u/ui-kit';

import { Content, CustomerUpdateModal, SearchCustomer, CustomerModalTitle } from 'components';
import { getCustomerTag } from 'helpers';
import { Condition, Customer } from 'types';
import { BookingStore, RootStore } from 'store';

export const CustomerSearchPage: FC = observer(() => {
  const navigate = useNavigate();
  const { setCustomer, setIsNewCustomer, customer } = BookingStore;
  const { user } = RootStore;
  const [showCustomerUpdateModal, setShowCustomerUpdateModal] = useState<boolean>(false);

  return (
    <Content dataTestId="customer-search-page" hasContainer>
      <title>Customer Search</title>
      <SearchCustomer
        hasQuickSearch
        syncParamsToUrl
        actions={[
          (customer) => getCustomerTag(customer),
          {
            title: 'View / Edit',
            action: (record: Customer) => {
              navigate(`/customer/edit/${record.ID}/details`);
            },
          },
          (customer) =>
            ([customer?.overdue, customer?.bad_debt].includes(Condition.Yes) && !user?.overdue_override) ||
            customer?.blacklist === Condition.Yes ? null : (
              <Link.$
                onClick={(e) => {
                  e.preventDefault();
                  setCustomer(customer);
                  setIsNewCustomer(false);
                  setShowCustomerUpdateModal(true);
                }}
              >
                Book a job
              </Link.$>
            ),
        ]}
      />

      <CustomerUpdateModal
        modalTitle={<CustomerModalTitle customerId={customer?.ID} notes={customer?.special_notes} />}
        okText="Confirm"
        isOpen={showCustomerUpdateModal}
        onOk={() => {
          setShowCustomerUpdateModal(false);
          navigate('/booking/location');
        }}
        onCancel={() => {
          setCustomer(null);
          setShowCustomerUpdateModal(false);
        }}
      />
    </Content>
  );
});
